import type { ReactNode } from 'react'

import { AppShell } from '@/domains/app-shell'
import { OnboardingShell, useSetupState } from '@/domains/setup'

/** picks the shell for /messages pages based on the caller's onboarding
 * state. users still in onboarding render inside the
 * onboarding-style OnboardingShell (only the onboarding sections + the
 * Messages nav item are visible). everyone else renders inside the
 * full AppShell.
 *
 * keeps the messages routes accessible during onboarding without
 * leaking the post-onboarding nav surface to a company that hasn't
 * finished setup yet.
 */
export function MessagingShell({
  title,
  children
}: {
  title: ReactNode
  children: ReactNode
}) {
  const { setupState } = useSetupState()
  const inOnboarding = setupState?.isOnboarding ?? false

  if (inOnboarding) {
    return <OnboardingShell title={title}>{children}</OnboardingShell>
  }
  return <AppShell title={title}>{children}</AppShell>
}
